// @flow
import * as React from "react"
import styled from "styled-components"
import Mobile from "@kiwicom/nitro/lib/components/Mobile"

import Cookies from "../Cookies/Cookies"

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  z-index: 610;
`

const CookiesMobile = () => (
  <Mobile>
    <Wrapper data-test="cookies-mobile">
      <Cookies />
    </Wrapper>
  </Mobile>
)

export default CookiesMobile
